import { render, staticRenderFns } from "./ApproveSalesNote.vue?vue&type=template&id=2639d770&scoped=true&"
import script from "./ApproveSalesNote.vue?vue&type=script&lang=js&"
export * from "./ApproveSalesNote.vue?vue&type=script&lang=js&"
import style0 from "./ApproveSalesNote.vue?vue&type=style&index=0&id=2639d770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639d770",
  null
  
)

export default component.exports